export const addToFavoritesText = "_Wa";
export default {addToFavoritesText};